import { Routes } from '@angular/router';
import { LoginComponent } from './routes/login/login.component';
import { loggedInGuard } from './guards/logged-in.guard';
import { permittedRouteGuard } from './guards/permitted-route.guard';
import { guestOnlyGuard } from './guards/guest-only.guard';
import { DashboardComponent } from './routes/dashboard/dashboard.component';
import { IntelligenceComponent } from './routes/intelligence/intelligence.component';
import { SamplesComponent } from './routes/samples/samples.component';
import { SamplesDetailsComponent } from './routes/samples/samples-details/samples-details.component';
import { CustomersComponent } from './routes/customers/customers.component';
import { IdBrowserComponent } from './routes/id-browser/id-browser.component';
import { LeaveManagementComponent } from './routes/leave-management/leave-management.component';
import { NotificationsComponent } from './routes/notifications/notifications.component';
import { RegionsComponent } from './routes/regions/regions.component';
import { ProductsComponent } from './routes/products/products.component';
import { ProductDetailsComponent } from './routes/products/product-details/product-details.component';
import { EvaluationsComponent } from './routes/evaluations/evaluations.component';
import { PlanDraftComponent } from './routes/plan-draft/plan-draft.component';
import { UsersComponent } from './routes/users/users.component';
import { UserDetailsComponent } from './routes/users/user-details/user-details.component';
import { PromotersComponent } from './routes/promoters/promoters.component';
import { SupervisorsPageComponent } from './routes/supervisors/supervisors-page.component';
import { SupervisorDetailsComponent } from './routes/supervisors/supervisor-details/supervisor-details.component';
import { CustomerServiceComponent } from './routes/customer-service/customer-service.component';
import { SalesComponent } from './routes/sales/sales.component';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    component: LoginComponent,
    path: 'login',
    canActivate: [guestOnlyGuard],
  },
  {
    path: '',
    canActivate: [loggedInGuard, permittedRouteGuard],
    children: [
      {
        path: 'dashboard',
        component: DashboardComponent,
      },
      {
        path: 'intelligences',
        component: IntelligenceComponent,
      },
      {
        path: 'samples',
        component: SamplesComponent,
      },
      {
        path: 'samples/:catalogueId/:productName',
        component: SamplesDetailsComponent,
      },
      {
        path: 'customers',
        component: CustomersComponent,
      },
      {
        path: 'id-browser',
        component: IdBrowserComponent,
      },
      {
        path: 'leave-management',
        component: LeaveManagementComponent,
      },
      {
        path: 'notifications',
        component: NotificationsComponent,
      },
      {
        path: 'regions',
        component: RegionsComponent,
      },
      {
        path: 'products',
        component: ProductsComponent,
      },
      {
        path: 'products/:id',
        component: ProductDetailsComponent,
      },
      {
        path: 'evaluations',
        component: EvaluationsComponent,
      },
      {
        path: 'plan-draft',
        component: PlanDraftComponent,
      },
      {
        path: 'users',
        component: UsersComponent,
      },
      {
        path: 'supervisors',
        component: SupervisorsPageComponent,
      },
      {
        path: 'supervisors/:id',
        component: SupervisorDetailsComponent,
      },
      {
        path: 'users/:id',
        component: UserDetailsComponent,
      },
      {
        path: 'promoters',
        component: PromotersComponent,
      },
      {
        path: 'customer-service',
        component: CustomerServiceComponent,
      },
      {
        path: 'sales',
        component: SalesComponent,
      },
    ],
  },
  {
    path: '**',
    canActivate: [loggedInGuard, permittedRouteGuard],
    children: [],
  },
];
